import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import { CartProvider } from './context/CartContext';
import { Toaster } from './components/ui/sonner';

import Navbar from './components/Navbar';
import Footer from './components/Footer';

import Home from './pages/Home';
import Shop from './pages/Shop';
import About from './pages/About';
import Contact from './pages/Contact';
import ThankYou from './pages/ThankYou';
import ProductDetail from './pages/ProductDetail';
import Cart from './pages/Cart';
import Login from './pages/Login';
import Register from './pages/Register';
import ResetPassword from './pages/ResetPassword';
import MyOrders from './pages/MyOrders';
import Profile from './pages/Profile';
import ReviewPage from './pages/ReviewPage';
import OrderSuccess from './pages/OrderSuccess';
import PaymentFailed from './pages/PaymentFailed';
import PaymentCallback from './pages/PaymentCallback';
import OrderTracking from './pages/OrderTracking';

import AdminRoute from './components/AdminRoute';
import AdminLayout from './layouts/AdminLayout';
import Admin from './pages/admin/Admin';
import AddProduct from "./pages/admin/AddProduct";
import AdminProducts from './pages/admin/AdminProducts';
import AdminCoupons from './pages/admin/AdminCoupons';
import EditProduct from './pages/admin/EditProduct';
import AdminDeliverySettings from './pages/admin/AdminDeliverySettings';
import AdminDataHub from './pages/admin/AdminDataHub';
import AdminInvoiceSettings from './pages/admin/AdminInvoiceSettings';

import AdminOrders from './pages/admin/AdminOrders';

import './index.css';

// âœ… Cart Initializer Component - Handles cart merging on login/logout



const getSafePage = (Component, name) => {
  if (Component) return Component;
  console.error(`${name} page is undefined. Check import/export in App.js.`);
  return () => (
    <div className="min-h-screen flex items-center justify-center">
      <div className="text-center">
        <h1 className="text-xl font-semibold text-amber-900 mb-2">Page unavailable</h1>
        <p className="text-amber-700">Please refresh and try again.</p>
      </div>
    </div>
  );
};

const SafePaymentCallback = getSafePage(PaymentCallback, 'PaymentCallback');
const SafeOrderTracking = getSafePage(OrderTracking, 'OrderTracking');

function App() {
  return (
    <AuthProvider>
      <CartProvider>
        <BrowserRouter>
          {/* âœ… CartInitializer must be inside CartProvider to access useCart */}
          
          <div className="min-h-screen flex flex-col">
            <Navbar />
            
            {/* Offset for fixed navbar */}
            <main className="pt-[80px] flex-1">
              <Routes>
                {/* PUBLIC ROUTES */}
                <Route path="/" element={<Home />} />
                <Route path="/shop" element={<Shop />} />
                <Route path="/about" element={<About />} />
                <Route path="/contact" element={<Contact />} />
                <Route path="/thank-you" element={<ThankYou />} />
                <Route path="/product/:slug" element={<ProductDetail />} />
                <Route path="/cart" element={<Cart />} />
                <Route path="/checkout" element={<ReviewPage />} />
                <Route path="/login" element={<Login />} />
                <Route path="/register" element={<Register />} />
                <Route path="/reset-password" element={<ResetPassword />} />
                <Route path="/my-orders" element={<MyOrders />} />
                <Route path="/profile" element={<Profile />} />
                <Route path="/review" element={<ReviewPage />} />
                <Route path="/order-success/:orderId" element={<OrderSuccess />} />
                <Route path="/payment-failed/:orderId" element={<PaymentFailed />} />
                <Route path="/payment-callback" element={<SafePaymentCallback />} />
                <Route path="/order-tracking/:orderNumber" element={<SafeOrderTracking />} />

                {/* ADMIN ROUTES â€“ PROTECTED */}
                <Route
                  path="/admin"
                  element={
                    <AdminRoute>
                      <AdminLayout />
                    </AdminRoute>
                  }
                >
                  <Route index element={<Admin />} />
                  <Route path="products" element={<AdminProducts />} />
                  <Route path="products/:id/edit" element={<EditProduct />} />
                  <Route path="products/new" element={<AddProduct />} />
                  <Route path="delivery" element={<AdminDeliverySettings />} />
                  <Route path="coupons" element={<AdminCoupons />} />
                  <Route path="orders" element={<AdminOrders />} />
                  <Route path="data-hub" element={<AdminDataHub />} />
                  <Route path="invoice-settings" element={<AdminInvoiceSettings />} />
                </Route>
                
                {/* 404 - Not Found Route */}
                <Route path="*" element={
                  <div className="min-h-screen flex items-center justify-center">
                    <div className="text-center">
                      <h1 className="text-4xl font-bold text-amber-950 mb-4">404</h1>
                      <p className="text-amber-700 mb-6">Page not found</p>
                      <a href="/" className="bg-amber-600 text-white px-6 py-3 rounded-xl hover:bg-amber-700">
                        Go Home
                      </a>
                    </div>
                  </div>
                } />
              </Routes>
            </main>

            <Footer />
            <Toaster position="bottom-right" richColors />
          </div>
        </BrowserRouter>
      </CartProvider>
    </AuthProvider>
  );
}

export default App;


